<div class="column content-container">
	<div class="content-container-header">
		<h3 i18n="@@addCompanyConfirmation" data-automation-id="addCompanyConfirmation"><b>Confirmation</b></h3>
		<mat-divider></mat-divider>

		<div class="content-container-body">
			@if (showLoading) {
				<div>
					<mat-spinner diameter="35" style="float: left"></mat-spinner>
					<h3 style="float: left; margin-top: 7px; margin-left: 1em" i18n="@@addCompanyConfirmation-loadingMessage">
						Loading...
					</h3>
				</div>
			}

			@if (showSuccess || confirmationType === 'addToMyList') {
				<div>
					@if (confirmationType === 'createCompany') {
						<div data-automation-id="addCompanyConfirmation-createCompanyConfirmationMessage">
							<ng-container i18n="@@addDeviceGroup-devicesAddedConfirmationPrefix"
								>This is a confirmation that</ng-container
							><ng-container>&nbsp;</ng-container><b>{{ companyName }}</b
							><ng-container>&nbsp;</ng-container>
							<ng-container i18n="@@addCompanyConfirmation-hasBeenAddedToThe">has been added to the</ng-container
							><ng-container>&nbsp;</ng-container>
							<i i18n="@@addCompanyConfirmation-publicDirectory">Public Directory</i><ng-container>&nbsp;</ng-container>
							<ng-container i18n="@@addCompanyConfirmation-andTo">and to</ng-container
							><ng-container>&nbsp;</ng-container>
							<i i18n="@@addCompanyConfirmation-myCompaniesList">My Companies List</i>.
							@if (email) {
								<br />
								<br />
								<div>
									<ng-container i18n="@@addCompanyConfirmation-verificationEmailSentTo"
										>A verification email has been sent to:</ng-container
									><br />
									<b>{{ email }}</b>
								</div>
							}
						</div>
					}
					@if (confirmationType === 'addToMyList') {
						<div i18n="@@addCompanyConfirmation-addToMyListConfirmationMessage">
							This is a confirmation that <b>{{ companyName }}</b> has been added to <i>My Companies List</i>.
						</div>
					}
					@if (alreadyTakenUsernames !== '') {
						<div style="display: flex; flex-direction: column; margin-top: 1em">
							<ng-container i18n="@@addCompanyConfirmation-APIusernameInUse"
								>Some API usernames are already in use:
							</ng-container>
							<b>{{ alreadyTakenUsernames }}</b>
						</div>
					}
				</div>
			}

			@if (showFailure) {
				<div>
					@if (confirmationType === 'createCompany') {
						<h3 i18n="@@addCompanyConfirmation-errorCreatingCompanyMessage">
							Error when creating {{ companyName }} or adding it to My Companies List
						</h3>
					}
					@if (confirmationType === 'addToMyList') {
						<h3 i18n="@@addCompanyConfirmation-errorAddingToMyListMessage">
							Error when adding {{ companyName }} to My Companies List
						</h3>
					}
				</div>
			}

			@if (showSuccess || showFailure) {
				<div>
					<div style="margin-top: 24px; margin-bottom: 24px">
						<mat-divider></mat-divider>
					</div>
					<div style="position: sticky; float: left; margin-top: 8px">
						<button
							mat-button
							class="primary-button"
							(click)="onReturnToPublicDirectoryClicked()"
							i18n="@@addCompanyConfirmation-returnToPublicDirectoryButton"
							data-automation-id="return-to-public-directory-button"
						>
							Return to Public Directory
						</button>
						@if (confirmationType === 'createCompany') {
							<button
								mat-button
								class="secondary-button"
								(click)="onAddAnotherCompanyClicked()"
								i18n="@@addCompanyConfirmation-addAnotherCompanyButton"
								data-automation-id="add-another-company-button"
							>
								+ Add Another Company
							</button>
						}
					</div>
				</div>
			}
		</div>
	</div>
</div>
